import { Observable, OperatorFunction, from, of, zip } from 'rxjs';
import { concatMap, groupBy, mergeMap, toArray } from 'rxjs/operators';

/**
 * Splits an observable by
 *
 * @param shouldSplitFunc - The type splitting func
 * @param trueFunc - The path to take when true
 * @param falseFunc - The path to take when false
 * @returns - The operator function to split the observable
 */
export function groupSplitObservable<T, S extends T, TrueRes, FalseRes>(
    shouldSplitFunc: (value: T) => value is S,
    trueFunc: (value: S) => Observable<TrueRes>,
    falseFunc: (value: T) => Observable<FalseRes>,
): OperatorFunction<T, FalseRes | TrueRes> {
    return obs$ =>
        obs$.pipe(
            groupBy((value): boolean => shouldSplitFunc(value)),
            mergeMap(groupedObservable$ => zip(of(groupedObservable$.key), groupedObservable$.pipe(toArray()))),
            mergeMap(([key, values]) => {
                if (key) {
                    return from(values).pipe(concatMap(val => trueFunc(val as S)));
                } else {
                    return from(values).pipe(concatMap(val => falseFunc(val)));
                }
            }),
        );
}
